export const CSV_IMPORT_COLUMNS = {
    FIRSTNAME: 'Firstname',
    LASTNAME: 'Lastname',
    EMAIL: 'Email',
    LANGUAGE: 'Language',
    WALLET_KEYS: 'Wallet Keys',
    STREET: 'Street',
    STREET_NUMBER: 'Street Number',
    ZIP: 'ZIP',
    CITY: 'City',
    COUNTRY_ALPHA2: 'Country Alpha2',
    COUNTRY_ALPHA3: 'Country Alpha3',
    BIRTH_DATE: 'BD',
    MOBILE: 'Mobile validated',
};
export const REQUIRED_CSV_COLUMNS = [
    CSV_IMPORT_COLUMNS.FIRSTNAME,
    CSV_IMPORT_COLUMNS.LASTNAME,
    CSV_IMPORT_COLUMNS.EMAIL,
    CSV_IMPORT_COLUMNS.LANGUAGE,
    CSV_IMPORT_COLUMNS.MOBILE,
];
export const MAX_IMPORT_ROWS = 1000;
//# sourceMappingURL=user-import.types.js.map